<template>
    <div>
        <div class="columns">
            <div class="column">
                <toHome />
            </div>
        </div>
        <div class="columns">
            <div class="column is-four-fifths ml-6">
                <h1 class="title is-size-5">Crea un saludo</h1>
                <div class="columns">
                    <div class="column is-half has-background-white">
                        <h2 class="subtitle is-size-6 has-text-weight-semibold">
                            Formulario para agregar saludo
                        </h2>
                        <form>
                            <b-field
                                class="file is-danger"
                                :class="{ 'has-name': !!data.image_72 }"
                            >
                                <b-upload
                                    v-model="data.image_72"
                                    class="file-label"
                                    ccept=".png, .jpg, .jpeg"
                                    title="Only images are allowed"
                                    name="image_72"
                                    id="image_72"
                                >
                                    <span class="file-cta">
                                        <span class="file-label"
                                            >Seleccionar imagen de 72dpi</span
                                        >
                                    </span>
                                    <span
                                        class="file-name"
                                        v-if="data.image_72"
                                    >
                                        {{ data.image_72.name }}
                                    </span>
                                </b-upload>
                            </b-field>
                            <b-field
                                class="file is-danger"
                                :class="{ 'has-name': !!data.image_300 }"
                            >
                                <b-upload
                                    v-model="data.image_300"
                                    class="file-label"
                                    ccept=".png, .jpg, .jpeg"
                                    title="Only images are allowed"
                                    name="image_300"
                                    id="image_300"
                                >
                                    <span class="file-cta">
                                        <span class="file-label"
                                            >Seleccionar imagen de 300dpi</span
                                        >
                                    </span>
                                    <span
                                        class="file-name"
                                        v-if="data.image_300"
                                    >
                                        {{ data.image_300.name }}
                                    </span>
                                </b-upload>
                            </b-field>
                            <b-field label="Titulo">
                                <b-input
                                    name="title"
                                    id="title"
                                    v-model="$v.data.title.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.title.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.title.minLength"
                            >
                                El Titulo debe tener al menos
                                {{ $v.data.title.$params.minLength.min }}
                                caracteres.
                            </span>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.title.maxLength"
                            >
                                El Titulo debe tener como máximo
                                {{ $v.data.title.$params.maxLength.max }}
                                caracteres.
                            </span>
                            <b-field label="subTitulo">
                                <b-input
                                    name="subtitle"
                                    id="subtitle"
                                    v-model="$v.data.subtitle.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.subtitle.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.subtitle.minLength"
                            >
                                El subTitulo debe tener al menos
                                {{ $v.data.subtitle.$params.minLength.min }}
                                caracteres.
                            </span>

                            <b-field label="Categoria">
                                <b-select
                                    placeholder="Selecione la categoria"
                                    v-model="$v.data.category_id.$model"
                                    name="category_id"
                                    id="category_id"
                                >
                                    <option
                                        v-for="option in categorySelectable"
                                        :value="option.id"
                                        :key="option.id"
                                    >
                                        {{ option.name }}
                                    </option>
                                </b-select>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.category_id.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <b-button type="is-danger" @click="sendData()"
                                >Crear</b-button
                            >
                        </form>
                    </div>
                    <div class="column ml-6">
                        <h3 class="title is-size-5">
                            Especificaciones técnicas de la imagen del saludo.
                        </h3>
                        <p>
                            Las imágenes deben estar a tamaño 12,5 x1 8,5 cm en
                            ambos casos y con el logo institucional en blanco o
                            gris dependiendo del contraste necesario.
                        </p>
                        <p>
                            Para esto pueden usar las plantillas PSD entregadas
                            que contienen las guías necesaria para crear un
                            nuevo saludo, para esto solo hay que arrastrar la
                            nueva imagen a una capa nueva y generar el archivo
                            de exportación
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <theLoader v-show="loadingStatus" />
    </div>
</template>
<script>
import { UrlCategory, UrlCreate } from '../../Url'
import theLoader from '../common/theLoader'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import toHome from '../common/theImgLinkToHome'

export default {
    components: {
        theLoader,
        toHome,
    },
    mounted() {
        this.fetchCategory()
    },
    data() {
        return {
            data: {
                image_72: null,
                image_300: null,
                title: '',
                subtitle: '',
                category_id: '',
            },
            categorySelectable: '',
            loadingStatus: false,
        }
    },
    validations: {
        data: {
            title: {
                required,
                maxLength: maxLength(5),
                minLength: minLength(4),
            },
            subtitle: {
                required,
                minLength: minLength(5),
            },
            category_id: {
                required,
            },
        },
    },
    methods: {
        fetchCategory: function () {
            const vm = this
            fetch(UrlCategory)
                .then((res) => res.json())
                .then((datos) => {
                    vm.categorySelectable = datos.data
                })
        },
        sendData() {
            const fileInput72 = document.querySelector('#image_72')
            const fileInput300 = document.querySelector('#image_300')
            const title = document.querySelector('#title').value
            const subtitle = document.querySelector('#subtitle').value
            const category_id = document.querySelector('#category_id').value
            const vm = this
            const formData = new FormData()
            formData.append('image_72', fileInput72.files[0])
            formData.append('image_300', fileInput300.files[0])
            formData.append('title', title)
            formData.append('subtitle', subtitle)
            formData.append('category_id', category_id)

            if (this.$v.$invalid) {
                this.$buefy.dialog.alert({
                    message:
                        '¡Ups! Aún queda información por validar. Por favor revise los datos ingresados y envíe el formulario nuevamente.',
                    confirmText: 'Entendido',
                })
            } else {
                this.loadingStatus = true
                let token = JSON.parse(
                    sessionStorage.getItem('vue-session-key')
                )
                fetch(UrlCreate, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        Authorization: 'Bearer ' + token.jwt,
                    },
                })
                    .then((res) => res.json())
                    .then(function (msg) {
                        vm.loadingStatus = false
                        if (msg.error) {
                            vm.$buefy.dialog.alert({
                                title: 'Error',
                                message: `<ul>
                                    <li>${
                                        msg.error.title
                                            ? msg.error.title
                                            : '<i class="fas fa-check"></i> Titulo Ok'
                                    }</li>
                                    <li>${
                                        msg.error.subtitle
                                            ? msg.error.subtitle
                                            : '<i class="fas fa-check"></i> Sub-titulo Ok'
                                    }</li>
                                    <li>${
                                        msg.error.image_72
                                            ? msg.error.image_72
                                            : '<i class="fas fa-check"></i> Imagen 72 Ok'
                                    }</li>
                                    <li>${
                                        msg.error.image_300
                                            ? msg.error.image_300
                                            : '<i class="fas fa-check"></i> Imagen 300 Ok'
                                    }</li>
                                       <li>${
                                           msg.error
                                               ? 'Por favor revise que las extenciones de las imagenes sean iguales'
                                               : '<i class="fas fa-check"></i> Extenciones iguales en Imagen Ok'
                                       }</li>
                                     </ul>`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true,
                            })
                        } else {
                            vm.$buefy.dialog.alert({
                                title: 'Creación completada',
                                message: `La tarjeta: <strong>${msg.title} </strong> ha sido creada exitosamente con el id <strong> ${msg.id} </strong>`,
                                type: 'is-success',
                                hasIcon: true,
                                icon: 'thumbs-up',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true,
                            })
                            vm.data = {}
                        }
                    })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.bg-create {
    background-color: #fafafa;
}
</style>
